import {Center, Icon, Image, keyframes, Spinner} from '@chakra-ui/react'
import Lottie from 'lottie-react'
import {useEffect, forwardRef, useImperativeHandle, useState} from 'react'
import * as animationData from '@assets/lotties/mic.json'
import {useRecord} from '@hooks/useRecord'
import {ReactComponent as MicIcon} from '@assets/svgs/mic_2.svg'

// Nên định nghĩa interface cho props
interface GlobalMicMiniProps {
  isDisabled?: boolean
  isLoading?: boolean
  handleStartRecording?: () => void
  handleRecordingComplete: (recordingBlob: Blob) => void
}

const pulseAnimation = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
`

const GlobalMicMini = (
  {
    isDisabled = false,
    isLoading = false,
    handleStartRecording = () => {},
    handleRecordingComplete,
  }: GlobalMicMiniProps,
  ref: any,
) => {
  const [isRecording, recordingBlob, startRecording, stopRecording] =
    useRecord()
  const [isTriggerComplete, setIsTriggerComplete] = useState(true)

  useEffect(() => {
    if (!recordingBlob || !isTriggerComplete) return
    handleRecordingComplete(recordingBlob)

    return () => {
      if (isRecording) {
        stopRecording()
      }
    }
  }, [recordingBlob])

  const handleClickMic = () => {
    if (isLoading && isDisabled) return
    if (isRecording) {
      stopRecording()
    } else {
      setIsTriggerComplete(true)
      handleStartRecording()
      startRecording()
    }
  }

  const getMicStatus = () => {
    return isRecording
  }

  const handleStopRecording = () => {
    setIsTriggerComplete(false)
    stopRecording()
  }

  useImperativeHandle(
    ref,
    () => ({
      getMicStatus,
      handleStopRecording,
      handleClickMic,
    }),
    [getMicStatus, handleStopRecording, handleClickMic],
  )

  return (
    <Center
      cursor={'pointer'}
      pointerEvents={isDisabled || isLoading ? 'none' : 'unset'}
      onClick={handleClickMic}>
      <Icon
        as={MicIcon}
        opacity={isDisabled || isLoading ? 0.4 : 1}
        w="20px"
        h="20px"
        animation={isRecording ? `${pulseAnimation} 1.5s infinite` : 'none'}
        sx={{
          path: {fill: isRecording ? '#FF4D4F' : '#98A2B3'},
        }}
      />
    </Center>
  )
}

export default forwardRef(GlobalMicMini)
